var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more-images") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0h-20A2.5 2.5 0 0 0 5 2.5v13.333a2.5 2.5 0 0 0 2.5 2.5h20a2.5 2.5 0 0 0 2.5-2.5V2.5A2.5 2.5 0 0 0 27.5 0zM11.62 3.333c.92 0 1.666.747 1.666 1.667s-.697 1.667-1.666 1.667c-.92 0-1.667-.747-1.667-1.667s.792-1.667 1.667-1.667zm14.114 11.23A.832.832 0 0 1 25 15H10a.833.833 0 0 1-.673-1.324l3.646-5a.833.833 0 0 1 1.347 0l1.163 1.597 3.268-4.902c.108-.23.369-.371.692-.371.278 0 .538.14.693.371l5.557 8.333a.833.833 0 0 1 .041.858zm-1.984 6.27H6.25a3.754 3.754 0 0 1-3.75-3.75v-12.5c0-.687-.56-1.25-1.25-1.25S0 3.896 0 4.583v12.5a6.256 6.256 0 0 0 6.25 6.25h17.5a1.25 1.25 0 0 0 0-2.5z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreImages);
export default __webpack_public_path__ + "static/media/more-images.6f08b7ba3f643a9d9c4ba74449a8ce46.svg";
export { ForwardRef as ReactComponent };